<template>
    <div class="media-project-close-task-page">
        <layout>
            <template v-slot:search>
              <div class="search-wrapper">
                <div class="title"><a-icon type="search" /> 数据筛选</div>
                <a-divider></a-divider>
                <a-space>
                    <!-- <a-select show-search allow-clear placeholder="所属主体" v-model="queryParam.corporation_id"  option-filter-prop="children">
                      <a-select-option :value="corporation.id" v-for="corporation in corporations" :key="corporation.id" >
                        {{ corporation.name }}
                      </a-select-option>
                    </a-select> -->
                    <a-select allow-clear placeholder="媒体" v-model="queryParam.media" show-search option-filter-prop="children">
                        <a-select-option :value="item.id" v-for="item in medias" :key="item.id" >
                            {{ item.name }}
                        </a-select-option>
                    </a-select>
                    <a-input allow-clear placeholder="任务ID" v-model="queryParam.id" />
                    <a-input allow-clear placeholder="广告主ID" v-model="queryParam.advertiser_id" />
                    <a-input allow-clear placeholder="广告主名称" v-model="queryParam.name" />
                    <a-input allow-clear placeholder="计划ID" v-model="queryParam.out_id" />
                    <a-input allow-clear placeholder="素材ID" v-model="queryParam.material_id" />
                    <a-select allow-clear placeholder="任务状态" v-model="queryParam.status" show-search option-filter-prop="children">
                      <a-select-option :value="item.id" v-for="item in taskStatus" :key="item.id" >
                          {{ item.name }}
                      </a-select-option>
                    </a-select>
                    <a-select allow-clear placeholder="任务类型" v-model="queryParam.type" show-search option-filter-prop="children">
                      <a-select-option :value="item.id" v-for="item in taskTypes" :key="item.id" >
                          {{ item.name }}
                      </a-select-option>
                    </a-select>
                    <a-select allow-clear placeholder="操作类型" v-model="queryParam.ope_type" show-search option-filter-prop="children">
                      <a-select-option :value="item.id" v-for="item in opeTypes" :key="item.id" >
                          {{ item.name }}
                      </a-select-option>
                    </a-select>
                    <a-select allow-clear placeholder="付费类型" v-model="queryParam.pay_type" show-search option-filter-prop="children">
                      <a-select-option :value="item.id" v-for="item in payTypes" :key="item.id" >
                          {{ item.name }}
                      </a-select-option>
                    </a-select>
                    <a-date-picker
                        v-model="queryParam.day"
                        valueFormat="YYYY-MM-DD"
                    />
                    <a-button type="primary" @click="search">查询</a-button>
                    <a-button @click="resetSearch">重置</a-button>
                    
                   
                </a-space>
               </div>
            </template>

            <template v-slot:content>

              <vxe-grid
                class="table-scrollbar"
                v-bind="tableGrid"
                @page-change="handlePageChange"
                @sort-change="handleSortChange"
              >

                <template #toolbar_buttons>
                  <a-space class="table-operator">
                    <a-button icon="upload" @click="upload" v-if="accessTo('upload')">批量导入</a-button>
                    <a-button type="danger" @click="showDeleteModal" v-if="accessTo('deleteAdvertiserProjects')">删除广告主项目</a-button>
                  </a-space>
                  <a-divider type="vertical" />
                </template>

                <template #taskStatus="{ row }">
                  <a-tag :color="row.status|statusColor">{{ $helper.getItemName(taskStatus, row.status) }}</a-tag>
                </template>

                <template #result="{ row }">
                  <div class="result" @click="showResult(row)">
                    <span>{{ row.success.length }}</span>/{{ row.success.length+row.errors.length }}
                  </div>
                </template>

                <template #actions="{ row }">
                  <template v-if="accessTo('tryAgain') && row.status == 3">
                    <a href="javascript:;" @click="tryAgain(row)">重试</a>
                    <!-- <a-divider type="vertical" /> -->
                  </template>
                  <template v-else>-</template>
                </template>
            
              </vxe-grid>
            </template>
        </layout>

        <a-modal
          title="执行结果"
          centered
          :width="640"
          :mask-closable="false"
          :visible="result.success.length + result.errors.length > 0"
          :footer="null"
          @cancel="close"
        >
          <div class="result-box">
            <div v-for="(item, index) in result.success" :key="'s' + index">{{ item }}</div>
            <div class="text-red" v-for="(item, index) in result.errors" :key="'e' + index"><br>{{ item }}</div>
          </div>
        </a-modal>

      <upload-form
        v-if="showUploadForm"
        :showUploadForm.sync="showUploadForm"
        :master="master"
        @success="refresh"
      />

      <a-modal
        title="删除广告主项目"
        centered
        :width="640"
        :mask-closable="false"
        :visible="deleteModalVisible"
        :confirmLoading="deleteLoading"
        @ok="handleDelete"
        @cancel="closeDeleteModal"
      >
        <a-form-model :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
          <a-form-model-item label="媒体">
            <a-select v-model="deleteForm.media" disabled>
              <a-select-option :value="item.id" v-for="item in medias" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="广告主">
            <a-textarea
              v-model="deleteForm.advertiser_ids"
              placeholder="请输入广告主ID，多个广告主请换行输入"
              :rows="8"
              :autoSize="{ minRows: 8, maxRows: 12 }"
            />
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
</template>

<style lang="less" scoped>
@import 'MediaProjectCloseTask';
</style>

<script>
import MediaProjectCloseTask from './MediaProjectCloseTask'
export default MediaProjectCloseTask
</script>
